import type { IperiaCoherenceAlert, IperiaCoherenceEditableKind } from '../types/iperiaStatus'

export const COHERENCE_CORRECTION_FAILED_MESSAGE =
  "Votre correction n'a pas pu être enregistrée. Réessayez, ou confirmez vos informations pour continuer."

/** La valeur enregistrée, telle que l'AM la reconnaît (date au format français, libellé du choix). */
export function formatCoherenceValue(alert: IperiaCoherenceAlert): string {
  const value = alert.value.trim()
  if (!value) return 'non renseigné'
  if (alert.editable?.kind === 'date' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return value.split('-').reverse().join('/')
  }
  if (alert.editable?.kind === 'choice') {
    return alert.editable.options.find((option) => option.value === value)?.label ?? value
  }
  return value
}

export function isConfirmable(alert: IperiaCoherenceAlert): boolean {
  return alert.confirmable !== false
}

/**
 * Les alertes d'un même point, en une carte : `point:champ` quand l'AM le corrige depuis
 * plusieurs champs (prénom et nom du parent employeur), dans l'ordre reçu.
 */
export function groupCoherenceAlerts(alerts: IperiaCoherenceAlert[]): IperiaCoherenceAlert[][] {
  const groups = new Map<string, IperiaCoherenceAlert[]>()
  for (const alert of alerts) {
    const key = alert.code.split(':')[0]
    groups.set(key, [...(groups.get(key) ?? []), alert])
  }
  return [...groups.values()]
}

export function coherenceInputType(kind: IperiaCoherenceEditableKind): string {
  if (kind === 'email') return 'email'
  if (kind === 'phone') return 'tel'
  if (kind === 'date') return 'date'
  return 'text'
}

/** Le message du serveur quand il refuse la valeur (400), sinon une phrase qui dit quoi faire. */
export function coherenceErrorMessage(error: unknown): string {
  const response = (error as { response?: { status?: number; data?: { detail?: unknown } } } | null)?.response
  const detail = response?.data?.detail
  if (response?.status === 400 && typeof detail === 'string' && detail.trim()) return detail
  if (response?.status === 503 && typeof detail === 'string' && detail.trim()) return detail
  return COHERENCE_CORRECTION_FAILED_MESSAGE
}
